// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__hdDXy","mainContent":"Dashboard_mainContent__VmYtf"};